import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TextField from "../../Components/common/TextField/TextField";

import {
  RequestGetHostname,
  RequestSetHostname,
  RequestUniqueId,
} from "../../store/actions/settingsActions";

const Hostname = () => {
  const dispatch = useDispatch();

  const hostnameDb = useSelector((state) => state.settings.hostname);

  const [hostname, setHostname] = useState(hostnameDb);

  useEffect(() => {
    dispatch(RequestGetHostname());
    dispatch(RequestUniqueId());
  }, [dispatch]);

  useEffect(() => {
    setHostname(hostnameDb);
  }, [hostnameDb]);

  const saveHostnameHandler = () => {
    const trimmedHostname = hostname.trim();
    if (!trimmedHostname || trimmedHostname === hostnameDb) return;

    dispatch(RequestSetHostname(hostname));
  };

  return (
    <div className="system-info__create flex-1">
      <h3>Public Host</h3>
      <p className="label">Hostname</p>
      <div className="system-info__create__group">
        <TextField
          onChange={(e) => setHostname(e.target.value)}
          value={hostname}
          placeholder={"Type Hostname"}
        />
        <div>
          <button onClick={saveHostnameHandler} className="primary-button">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hostname;
